import { useRef } from "react"

import cls from "classname"

import ActiveMerchantsCard from "./cards/ActiveMerchants/ActiveMerchantsCard"
import AverageValueCard from "./cards/AverageValue/AverageValueCard"
import LookupsOverviewCard from "./cards/LookupsOverview/LookupsOverviewCard"
import LookupVolumeCard from "./cards/LookupVolume/LookupVolumeCard"
import MatchRateCard from "./cards/MatchRate/MatchRateCard"
import RecordsByStatusCard from "./cards/RecordsByStatus/RecordsByStatusCard"
import RevenueCard from "./cards/Revenue/RevenueCard"
import TimeToActiveCard from "./cards/TimeToActive/TimeToActiveCard"
import UnbillableChannelsCard from "./cards/UnbillableChannels/UnbillableChannelsCard"
import AdminDeflectFilters from "./components/AdminDeflectFilters"
import { Block, BlockSlot } from "./components/Block/Block"
import SectionNav from "./components/SectionNav/SectionNav"
import { BLOCKS } from "./constants"
import { useIntroMotion } from "./hooks/useIntroMotion"

import styles from "./adminDeflectAnalytics.module.less"

// Admin Analytics → Deflect (CHA1-3495), Super Admin only. Shares /deflect/analytics with the merchant
// Deflect Analytics page. No title: the page opens with its filter row (DAA-1-06), then the four
// blocks (DAA-1-07), each with its cards in the order of DAA-1-08.
const BLOCK_CARDS = {
  volume: (
    <>
      <BlockSlot>
        <LookupsOverviewCard />
      </BlockSlot>
      <BlockSlot>
        <LookupVolumeCard />
      </BlockSlot>
      {/* Full width, Unbillable channels under Active merchants (CHA1-4558). */}
      <BlockSlot>
        <ActiveMerchantsCard />
      </BlockSlot>
      <BlockSlot>
        <UnbillableChannelsCard />
      </BlockSlot>
    </>
  ),
  matching: (
    <BlockSlot>
      <MatchRateCard />
    </BlockSlot>
  ),
  money: (
    <>
      <BlockSlot>
        <RevenueCard />
      </BlockSlot>
      <BlockSlot>
        <AverageValueCard />
      </BlockSlot>
    </>
  ),
  enrollment: (
    <>
      <BlockSlot>
        <RecordsByStatusCard />
      </BlockSlot>
      <BlockSlot>
        <TimeToActiveCard />
      </BlockSlot>
    </>
  )
}

const AdminDeflectAnalyticsPage = () => {
  const pageRef = useRef(null)

  useIntroMotion(pageRef, styles.intro)

  return (
    // `dashboard-page`: the platform's page padding, chart cards and breakdown tables, as on the
    // Alerts Dashboard.
    <div ref={pageRef} className={cls("dashboard-page", styles.page)}>
      <div data-intro>
        <AdminDeflectFilters />
      </div>
      {BLOCKS.map((block) => (
        <Block key={block.id} block={block}>
          {BLOCK_CARDS[block.id]}
        </Block>
      ))}
      <SectionNav blocks={BLOCKS} />
    </div>
  )
}

export default AdminDeflectAnalyticsPage
